<div class="content">
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 common_title">
          <h2>ADD - STOCK MANAGEMENT</h2>
          <p>Create Stock record</p>
          <!-- <a (click)="backnavigate()" class="back_to"><i class="fa fa-chevron-left" aria-hidden="true"></i>
      Back
     </a>-->
        </div>
      </div>
      <form [formGroup]="registerForm" class="row bottomheight">
        <div class="col-lg-4 col-md-6 col-sm-6 dropdowntop">
          <div class="form-group multiple">
            <label for="Species Name" class="farmmulti"><span class="dec">Farm Name</span></label>
            <select name="farmname" id="farmname" class="form-control selectpicker myFakeClass"
              formControlName="farmNamev"
              [ngClass]="{ 'is-invalid': submitted && f.farmNamev.errors }">
              <option selected disabled value="">Select Farm Name</option>
              <option *ngFor='let farmlist of getfarmsListData' [value]="farmlist.tnfr_id">{{farmlist.tnfr_name}}
              </option>
            </select>
            <!--(change)="breedselectbyspecies($event)" -->
            <!--error part--->
            <div *ngIf="submitted && f.farmNamev.errors" class="invalid-feedback">
              <div class="selectvalidate" *ngIf="f.farmNamev.errors.required">Farm name must be filled out</div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 dropdowntop">
          <div class="form-group">
            <label for="Species Name"><span class="dec">Species Name</span></label>
            <select id="Speciesname" class="form-control selectpicker myFakeClass1"
              (change)="breedselectbyspecies($event)" formControlName="speciesNamev">
              <option selected disabled value="">Select species</option>
              <option *ngFor='let specieslist of speciesloaddata' [value]="specieslist.id">{{specieslist.name}}</option>
            </select>
            <div *ngIf="submitted && f.speciesNamev.status=='INVALID'">
              <div class="selectvalidate" *ngIf="f.speciesNamev.errors.required">Species name must be filled out</div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 dropdowntop">
          <div class="form-group">
            <label for="Breed Name"><span class="dec">Breed Name</span></label>
            <select id="BreedName" class="form-control selectpicker myFakeClass2" formControlName="breedNamev"
              [ngClass]="{ 'is-invalid': submitted && f.breedNamev.errors }">
              <option selected disabled value="">Select Breeds</option>
              <option *ngFor='let breedname of getspeciesvalue' [value]="breedname.id">{{breedname.name}}</option>
            </select>
            <div *ngIf="submitted && f.breedNamev.status=='INVALID'">
              <div class="selectvalidate" *ngIf="f.breedNamev.errors.required">Breed name must be filled out</div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label for="Species Name">Date of Birth</label>
            <input type="date" name="birthdate" id="birthdate" (change)="getdateofbirth($event)" value="" 
              formControlName="birthdatev" class="form-control datehide"
              [ngClass]="{ 'is-invalid': submitted && f.birthdatev.errors }">
            <div *ngIf="submitted && f.birthdatev.errors" class="invalid-feedback">
              <div class="selectvalidate" *ngIf="f.birthdatev.errors.required">Date of Birth must be filled out</div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 dropdowntop">
          <div class="form-group">
            <label for="Species Name"><span class="dec">Age Group</span></label>
            <select id="agetype" class="form-control selectpicker myFakeClass3" formControlName="agegroup">
              <option selected disabled value="">Select Age</option>
              <option *ngFor='let agelist of ageListData ' [value]="agelist.tnag_id">{{agelist.tnag_name}}</option>
            </select>
            <div *ngIf="submitted && f.agegroup.status=='INVALID'">
              <div class="selectvalidate" *ngIf="f.agegroup.errors.required">Breed name must be filled out</div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label for="Species Name">Animal ID</label>
            <input type="text" name="adddose" id="animalid" value="" class="form-control" formControlName="animalidv"
              [ngClass]="{ 'is-invalid': submitted && f.animalidv.errors }">
            <div *ngIf="submitted && f.animalidv.errors" class="invalid-feedback">
              <div class="selectvalidate" *ngIf="f.animalidv.errors.required">Animal ID must be filled out</div>
            </div>
          </div>
        </div>
        <!--<div class="col-lg-4 col-md-6 col-sm-6">
                  <label for="Species Name">Height</label>
                  <div class="form-group">
                    <input type="text" name="adddose" id="getHeight"  value="" class="form-control">
                    </div>
                 </div>-->
        <div class="col-lg-4 col-md-6 col-sm-6 dropdowntop">
          <div class="form-group">
            <label>Gender</label>
            <select id="gender" class="selectpicker form-control myFakeClass4" formControlName="gender">
              <option selected disabled value="">Select Gender</option>
              <option>Male</option>
              <option>Female</option>
            </select>
            <div *ngIf="submitted && f.gender.status=='INVALID'">
              <div class="selectvalidate" *ngIf="f.gender.errors.required">Gender must be filled out</div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label for="Species Name">Weight (kg)</label>
            <input type="text" name="adddose" id="getWeight" value="" class="form-control" formControlName="weight"
              [ngClass]="{ 'is-invalid': submitted && f.weight.errors }">
            <div *ngIf="submitted && f.weight.errors" class="invalid-feedback">
              <div class="selectvalidate" *ngIf="f.weight.errors.required">Weight must be filled out</div>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label for="Species Name">Date of Transfer</label>
            <input type="date" name="transferdate" id="transferdate" (change)="deletiondateselect($event)" value=""
              class="form-control">

          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label for="Species Name">Date of Purchase</label>
            <input type="date" name="purchasedate" id="purchasedate" value="" class="form-control">
          </div>
        </div>

        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label for="Species Name"> Date of Deletion</label>
            <input type="date" name="deletiondate" id="deletiondate" (change)="deletiondateselect($event)" value=""
              class="form-control">
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 dropdowntop">
          <div class="form-group">
            <label for="Species Name"><span class="dec">Status</span></label>
            <select id="Status" class="selectpicker form-control myFakeClass5">
              <option value="1">Active</option>
              <option value="0">Inactive</option>
            </select>
            <!-- <div  *ngIf="submitted && f.status.status=='INVALID'">
                <div class="selectvalidate" *ngIf="f.status.errors.required">Status must be filled out</div>
            </div> -->
          </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 text-center">
          <a (click)="onSubmit()" class="btn btn-fill btn-primary mb-3">
            Submit
            <div class="ripple-container"></div>
          </a>
          <button (click)=backnavigate() class="btn btn-fill btn-default">Cancel
            <div class="ripple-container"></div>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>